import '@/lib/schemaRuntime';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/fonts';
import '@/styles/tailwind.css';
import i18n, { initI18n, resources } from '@/i18n';
import { updateEntryLoading, showEntryFailure } from '@/lib/entryLoading';
import App from './App';

async function enableMocking() {
  // yarn dev:mock (VITE_ENABLE_MSW=true) 에서만 목업을 켠다. 빌드 시 상수로 치환되어 운영 번들에서 제외된다.
  if (import.meta.env.VITE_ENABLE_MSW !== 'true') return;
  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledFrame: 'bypass' });
}

async function bootstrap() {
  await enableMocking();
  await initI18n();
  updateEntryLoading({
    label: i18n.t('entry.label'),
    message: i18n.t('entry.message'),
    helpMessage: i18n.t('entry.slow'),
    home: i18n.t('entry.home'),
  });
  createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap().catch(() => {
  showEntryFailure({
    message: i18n.isInitialized
      ? i18n.t('entry.failed')
      : resources.en.common.entry.failed,
    retry: i18n.isInitialized
      ? i18n.t('entry.retry')
      : resources.en.common.entry.retry,
  });
});
